export const LOAD_PAYMENT_METHOD = 'LOAD_PAYMENT_METHOD'
